var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 733.39 721.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c562c5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_We_are") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.9,271.24C79.1,298.58,32.5,332.12,12.54,378c-19.14,44-11,93,.7,139,12.11,47.35,29.15,96.07,68.4,131.37,60,54,155.57,63.45,242.71,68.32,69.82,3.9,144.34,6,204.52-24,31.18-15.57,56-38.73,78.62-62.69,66.42-70.46,118.79-154.44,124-244.68S686.3,198.85,591.07,158C591.07,158,273.73,139.48,126.9,271.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.83,26.61c-.45,3.14-.56,6.51.91,9.33s4.05,4.52,6.69,6.05,5.69,3,8.83,2.94c4.81-.09,8.79-3.58,12.24-6.92,2.76-2.68,5.62-5.63,6.4-9.4a16.77,16.77,0,0,0-.11-5.95c-.93-5.79-3-11.6-7.17-15.76S406,.6,400.52,2.7C400.52,2.7,387.92,14.85,388.83,26.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328,118.66c-.89,6.22-1.11,12.88,1.79,18.46,2.78,5.35,8,8.93,13.24,11.95,5.38,3.12,11.25,6,17.47,5.83,9.5-.19,17.37-7.08,24.19-13.7,5.47-5.3,11.11-11.13,12.65-18.59a32.76,32.76,0,0,0-.22-11.76c-1.84-11.45-6-22.94-14.18-31.15s-21-12.47-31.82-8.31C351.13,71.39,326.21,95.42,328,118.66Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAbout);
export default __webpack_public_path__ + "static/media/bg_about.cc692ecd49993f0ae0bab9ceefaef8f6.svg";
export { ForwardRef as ReactComponent };